// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import AlipaySvg from '@rsuite/icon-font/lib/platform/Alipay';
var Alipay = createSvgIcon({
  as: AlipaySvg,
  ariaLabel: 'alipay',
  category: 'platform',
  displayName: 'Alipay'
});
export default Alipay;